import * as React from "react";

const SvgComponent = (props) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.625.625H1.375a.75.75 0 0 0-.75.75v17.25c0 .415.335.75.75.75h17.25a.75.75 0 0 0 .75-.75V1.375a.75.75 0 0 0-.75-.75Zm-.938 17.063H2.313V2.313h15.376v15.374ZM9.531 7.374h4.313a.188.188 0 0 0 .187-.188V6.063a.188.188 0 0 0-.187-.187H9.53a.188.188 0 0 0-.187.188v1.125c0 .103.084.187.187.187Zm0 3.375h4.313a.188.188 0 0 0 .187-.188V9.438a.188.188 0 0 0-.187-.188H9.53a.188.188 0 0 0-.187.188v1.124c0 .104.084.188.187.188Zm0 3.375h4.313a.188.188 0 0 0 .187-.188v-1.124a.188.188 0 0 0-.187-.188H9.53a.188.188 0 0 0-.187.188v1.124c0 .104.084.188.187.188Zm-3.562-7.5a.937.937 0 1 0 1.875 0 .937.937 0 0 0-1.875 0Zm0 3.375a.937.937 0 1 0 1.875 0 .937.937 0 0 0-1.875 0Zm0 3.375a.937.937 0 1 0 1.875 0 .937.937 0 0 0-1.875 0Z"
      fill="#4F4F4F"
    />
  </svg>
);

export default SvgComponent;
